import { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';

import { selectLegalInfo, selectOffer, selectOfferId } from 'shared/selectors/offerData';
import { getDealType, isRent } from 'shared/utils/deal_type';

import { trackButtonClick, trackLinkClick } from './tracking';

export const useLegalInfoModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const legalInfo = useSelector(selectLegalInfo);
  const offer = useSelector(selectOffer);
  const offerId = useSelector(selectOfferId);

  const isRentOffer = isRent(getDealType(offer));
  const hasFields = (legalInfo?.fields?.length || 0) > 0;
  const isVisible = isRentOffer && hasFields;

  const closeModal = useCallback(() => setIsOpen(false), []);
  const handleButtonClick = useCallback(() => {
    setIsOpen(true);
    trackButtonClick(offerId);
  }, [offerId]);
  const handleLinkClick = useCallback(() => {
    trackLinkClick(offerId);
  }, [offerId]);

  return {
    isOpen,
    handleButtonClick,
    handleLinkClick,
    closeModal,
    legalInfo,
    isVisible,
  };
};
